// src/app/Navigation.jsx — la barre du haut, la barre du bas (téléphone) et
// les sous-onglets. Déplacés à l'identique depuis src/App.jsx (P-3.5, squelette).

import { Fragment } from 'react'
import { DS } from '../lib/ui'
import Icon, { NAV_ICON } from '../lib/Icon'
import { LogOut } from 'lucide-react'
import BoutonMicro from '../views/accueil/BoutonMicro'
import BarreOperateur from '../views/accueil/BarreOperateur'
// ADR-269 — badges de notification des menus PARENTS (barre principale).
import NavBadge from '../components/NavBadge'
import { badgeAriaLabel, tonPastilleMenu } from '../lib/nav-badges'
import BarreUnique, { styleOngletBarre, couleurIconeOnglet } from '../components/BarreUnique'
import BarreOngletsBas from '../components/BarreOngletsBas'
import CadreAgent from './CadreAgent'
import TiroirMenu from './TiroirMenu'
import { LOGO_NEST } from '../assets/logo-nest'

export function barreDuHaut({
  setTab, tab, setMenuPastille, menuPastille, handleLogout, icalRefreshing, navBadges, navBadgeTons,
  isAdmin, isMenage, isOrchestrateur, CATEGORIES, activeCategory, setCategory, beds24Freshness,
  currentUser,
}) {
  // L'agent de ménage a son propre cadre, d'après la maquette NEST v677.
  if (isMenage) {
    return (
      <CadreAgent currentUser={currentUser} categories={CATEGORIES} onChoisir={setCategory}
        activeId={activeCategory ? activeCategory.id : null} onDeconnexion={handleLogout} />
    )
  }
  return (
    <>
      {/* ── LA BARRE UNIQUE (maquette 2026-08-15) ── */}
      {/* Le bandeau sombre et la barre d'onglets ont FUSIONNÉ : ~70 px gagnés,
          l'écran commence sur le contenu. Le dégradé + lotus vivent désormais
          sur la carte de titre de chaque page (CarteTitrePage v2). 0 logique
          touchée : sync, badges, catégories et Déconnexion inchangés. */}
      <BarreUnique
        // LOT 2 : l'admin aussi — sur téléphone les CINQ vivent dans la
        // barre du bas (proto), la barre du haut garde marque + micro +
        // pastille Réglages + Déconnexion.
        masquerOngletsEtroit={isOrchestrateur || isMenage || isAdmin}
        logo={isAdmin ? LOGO_NEST : null}
        marque={isAdmin ? 'NEST' : undefined}
        gauche={isAdmin ? <TiroirMenu categories={CATEGORIES} activeId={activeCategory ? activeCategory.id : null}
          onChoisir={setCategory} onReglages={() => setTab('params')} badges={navBadges} /> : null}
        enfants={CATEGORIES.map(c => {
          const isActive = !!activeCategory && activeCategory.id === c.id
          // ADR-269 — badge parent (admin) + badge orchestrateur (incidents à
          // juger du pool ; Stock suivra sa refonte). Corail RÉSERVÉ aux badges.
          const badge = ((isAdmin || isOrchestrateur) && navBadges[c.id]) || 0
          const cleanLabel = String(c.label).replace(/^[^A-Za-zÀ-ÿ]+\s*/, '')
          return (
            <button key={c.id} onClick={() => setCategory(c.id)}
              className="fbz-cible-tactile"
              aria-label={badge > 0 ? badgeAriaLabel(cleanLabel, badge) : undefined}
              aria-current={isActive ? "page" : undefined}
              style={styleOngletBarre(isActive)}>
              {c.Icone
                ? <c.Icone size={16} strokeWidth={2} color={couleurIconeOnglet(isActive)} aria-hidden="true" />
                : c.ic
                ? <span aria-hidden="true" style={{fontSize:15,lineHeight:1}}>{c.ic}</span>
                : NAV_ICON[c.id] && <Icon name={NAV_ICON[c.id]} size={17} color={couleurIconeOnglet(isActive)} />}
              {cleanLabel}
              <NavBadge count={badge} tone={tonPastilleMenu({ isAdmin, tons: navBadgeTons, id: c.id })}
                testId={`nav-badge-${c.id}`} />
            </button>
          )
        })}
        droite={<>
          {(icalRefreshing || beds24Freshness?.hasData) && (
            <div style={{display:"flex",alignItems:"center",gap:5}}
              title={
                icalRefreshing
                  ? "Synchronisation en cours…"
                  : beds24Freshness?.iso
                    ? `Dernier signal Beds24 (webhook ou pull cron) : ${Number.isNaN(new Date(beds24Freshness.iso).getTime()) ? '—' : new Date(beds24Freshness.iso).toLocaleString('fr-FR')}${beds24Freshness.stale ? " — en retard (> 1h)" : ""}`
                    : undefined
              }>
              <span style={{width:7,height:7,borderRadius:"50%",background: beds24Freshness?.stale ? DS.warning : DS.success,flexShrink:0,boxShadow: beds24Freshness?.stale ? "0 0 0 3px rgba(239,159,39,.25)" : "0 0 0 3px rgba(29,158,117,.25)"}} />
              {/* v3 : l'HEURE saute (les onglets ont grossi, FULLBNBZEN est
                  gardé — consigne) ; elle vit dans l'infobulle du point. */}
            </div>
          )}
          {/* ⚠️ LE MICRO DE L'OPÉRATEUR — posé ICI, donc présent sur TOUTES les
              pages de l'admin (§4 du cadrage), et sur elles SEULES. Sur
              téléphone il se rend dans la barre ; sur ordinateur le composant
              se rend lui-même flottant en bas à droite. */}
          {/* « il écoute, récite ce qu'il a compris, EMMÈNE » — le troisième
              geste de la maquette : le panneau ne peut rien envoyer, il ouvre
              la destination, où les gardes d'envoi vivent déjà. */}
          {isAdmin && <BoutonMicro ordinateurSeul onEmmener={() => setTab('operateur')} />}
          {/* LA BARRE DE L'OPÉRATEUR — ordinateur, hors accueil, hors opérateur
              (décision 2026-09-07). ⚠️ Elle COEXISTE avec le micro flottant :
              « ne retire rien avant d'avoir le remplaçant » — le retrait du
              micro ET de sa réserve de 88 px viendra APRÈS vérification.
              ⚠️ RÉSOLUTION 2026-09-08 : ce conflit n'était PAS additif. #1301
              donnait `onEmmener` au micro pendant que main ajoutait la barre.
              Garder les deux côtés aveuglément aurait rendu le micro muet
              (perte de onEmmener) OU supprimé la barre. Les deux sont ici,
              chacun avec ce qui lui appartient. */}
          {isAdmin && <BarreOperateur tab={tab} onOuvrir={() => setTab('operateur')} />}
          {/* ── LA PILULE « L'OPÉRATEUR » A ÉTÉ RETIRÉE (2026-09-13) ──────
              Dimitri : « Elle n'avait plus de sens : l'accueil EST sa page.
              Son journal et sa mémoire se demandent maintenant. »

              ⚠️ L'ÉCRAN `operateur` RESTE ROUTABLE et n'est pas orphelin : le
              bloc de l'accueil y renvoie dès qu'une réponse attend un accord
              (« N réponses attendent votre accord »), et c'est le seul moment
              où on a une raison d'y aller. Retirer la pilule ET ce renvoi
              enfermerait les décisions dans un écran sans porte. */}
          {/* LOT 2 (arbitrage Dimitri 2026-08-26) — la pastille de compte
              « FZ · Réglages ▾ » porte les RÉGLAGES ET LA DÉCONNEXION :
              c'est là qu'on les cherche. Le menu ne les montre plus. */}
          {isAdmin ? (
            <span style={{position:"relative",display:"inline-flex"}}>
              <button onClick={() => setMenuPastille(v => !v)} className="fbz-press"
                data-testid="pastille-reglages"
                aria-expanded={menuPastille}
                aria-current={tab === 'params' ? 'page' : undefined}
                style={{display:"inline-flex",alignItems:"center",gap:6,
                  background: tab === 'params' || menuPastille ? DS.ciel : "transparent",
                  color:"#3d4a57",border:"1px solid #e0e4e8",borderRadius:19,
                  padding:"5px 11px 5px 5px",fontSize:11,cursor:"pointer",
                  fontFamily:DS.fontBody,fontWeight:600,minHeight:38}}>
                <span aria-hidden="true" style={{width:26,height:26,borderRadius:"50%",
                  background:"#3d5166",color:"#fff",fontSize:10.5,fontWeight:700,
                  display:"inline-flex",alignItems:"center",
                  justifyContent:"center"}}>FZ</span>
                <span className="fbz-pastille-nom">Réglages</span>
                <span style={{fontSize:10,color:"#98a2ad"}}>▾</span>
              </button>
              {menuPastille && (
                <>
                  {/* le voile : un toucher à côté referme, rien d'autre */}
                  <span onClick={() => setMenuPastille(false)}
                    style={{position:"fixed",inset:0,zIndex:89}} />
                  <span data-testid="pastille-menu" role="menu"
                    style={{position:"absolute",top:"calc(100% + 6px)",right:0,
                      zIndex:90,minWidth:172,background:"#fff",
                      border:"1px solid #e0e4e8",borderRadius:12,
                      boxShadow:"0 8px 26px rgba(35,50,64,.16)",padding:5,
                      display:"flex",flexDirection:"column"}}>
                    <button role="menuitem" data-testid="pastille-ouvrir-reglages"
                      onClick={() => { setMenuPastille(false); setTab('params') }}
                      className="fbz-press"
                      style={{display:"flex",alignItems:"center",gap:8,
                        padding:"10px 12px",minHeight:42,border:"none",
                        background:"none",borderRadius:8,fontSize:12,
                        fontWeight:600,color:"#3d4a57",cursor:"pointer",
                        fontFamily:DS.fontBody,textAlign:"left"}}>
                      ⚙ Réglages
                    </button>
                    {/* ── LA PORTE DE L'OPÉRATEUR (2026-09-13) ──────────
                        La pilule du bandeau est partie : l'accueil EST sa
                        page. Mais son ÉCRAN garde ce qui ne se demande pas en
                        conversation — ses réglages, ses plans, son
                        coupe-circuit. Sans cette entrée, ils n'auraient plus
                        aucune porte le jour où rien n'attend d'accord (le
                        renvoi de l'accueil ne s'allume que dans ce cas-là). */}
                    <button role="menuitem" data-testid="pastille-ouvrir-operateur"
                      onClick={() => { setMenuPastille(false); setTab('operateur') }}
                      className="fbz-press"
                      style={{display:"flex",alignItems:"center",gap:8,
                        padding:"10px 12px",minHeight:42,border:"none",
                        background:"none",borderRadius:8,fontSize:12,
                        fontWeight:600,color:"#3d4a57",cursor:"pointer",
                        fontFamily:DS.fontBody,textAlign:"left"}}>
                      ◉ L&rsquo;opérateur
                    </button>
                    <button role="menuitem" data-testid="pastille-deconnexion"
                      onClick={() => { setMenuPastille(false); handleLogout() }}
                      className="fbz-press"
                      style={{display:"flex",alignItems:"center",gap:8,
                        padding:"10px 12px",minHeight:42,border:"none",
                        background:"none",borderRadius:8,fontSize:12,
                        fontWeight:600,color:"#5c6773",cursor:"pointer",
                        fontFamily:DS.fontBody,textAlign:"left"}}>
                      <LogOut size={13} strokeWidth={2.2}/> Déconnexion
                    </button>
                  </span>
                </>
              )}
            </span>
          ) : (
            <button onClick={handleLogout} className="fbz-press" style={{display:"inline-flex",alignItems:"center",gap:5,background:"transparent",color:"#5c6773",border:"1px solid #e0e4e8",borderRadius:8,padding:"6px 11px",fontSize:10.5,cursor:"pointer",fontFamily:DS.fontBody,fontWeight:600,minHeight:44}}>
            <LogOut size={12} strokeWidth={2.2}/> Déconnexion
          </button>
          )}
        </>} />
    </>
  )
}

export function navigationOnglets({
  setTab, tab, notif, aConfirmer, navBadgesIncidents, navBadges, isAdmin, isMenage, isOrchestrateur,
  CATEGORIES, activeCategory, setCategory,
}) {
  return (
    <>
      {/* TÉLÉPHONE (cadrage définitif 2026-08-22) : la navigation EN BAS,
          fixe, à portée de pouce — le composant se tait sur écran large.
          ⚠️ L'ADMIN L'A AUSSI DEPUIS LE LOT 1 (2026-08-26). Il ne l'avait
          jamais eue : sur téléphone, quitter un écran admin demandait de
          remonter et de faire défiler la barre du haut à l'horizontale.
          MAQUETTE NEST v677 : Accueil · Calendrier · l'opérateur · Opérations ·
          Voyageurs ; Logements et Argent dans le menu ☰ (TiroirMenu). */}
      {(isOrchestrateur || isAdmin) && (
        <BarreOngletsBas categories={CATEGORIES} activeId={activeCategory ? activeCategory.id : null}
          onChoisir={setCategory} badges={navBadges} nest={isAdmin}
          centre={isAdmin ? <BoutonMicro dansBarreBas onEmmener={() => setTab('operateur')} /> : null} />
      )}

      {/* ── NAV SECONDAIRE : sous-onglets de la catégorie active (si > 1). ──
          ⚠️ JAMAIS chez l'orchestrateur (Dimitri 2026-08-19) : ses groupes
          Planning / À décider ont leur BASCULE maquette dans le contenu —
          cette barre générique doublonnait au-dessus. Elle reste pour les
          familles admin (Gestion, Opérations…). */}
      {/* LOT 3 : pour ◷ Aujourd'hui (admin), la bascule du PROTO remplace
          cette barre générique — elle vit dans le chrome, sous le bandeau. */}
      {/* LOT 5 : idem pour € Argent — la bascule à cinq du chrome (avec
          Statistiques → phrase de révision) remplace cette barre. */}
      {!isOrchestrateur && activeCategory && activeCategory.tabs.length > 1
        && !(isAdmin && (activeCategory.id === 'jour' || activeCategory.id === 'argent' || activeCategory.id === 'voyageurs')) && (
        <div className="fbz-scroll-x" style={{background:"#f8fafd",borderBottom:"1px solid #eef2f7",display:"flex",alignItems:"center",justifyContent:"center",gap:4,overflowX:"auto",padding:"6px 12px"}}>
          {activeCategory.tabs.map(([id, label]) => {
            // Gestion : 2 familles visuelles séparées d'un léger filet vertical.
            // « Suivi proprio » (Données · Facturation · Historique) puis
            // « Entreprise » (Compta · Statistiques). Le filet précède Compta.
            // LOT 2 : « Argent » garde le filet entre le suivi proprio
            // (Données · Facturation · Historique) et l'entreprise
            // (Compta · Statistiques) — la même séparation qu'avant.
            const showFamilySep = activeCategory.id === "argent" && id === "compta"
            return (
              <Fragment key={id}>
                {showFamilySep && (
                  <span aria-hidden="true" style={{width:1,alignSelf:"stretch",margin:"7px 12px",background:"#dbe3ee",flexShrink:0}} />
                )}
                <button onClick={() => setTab(id)}
                  aria-current={tab===id ? "page" : undefined}
                  style={{display:"inline-flex",alignItems:"center",gap:5,padding:"6px 11px",fontSize:11.5,fontWeight:tab===id?700:500,color:tab===id?"#1c2833":"#5c6773",background:tab===id?DS.ciel:"none",border:"none",borderRadius:20,cursor:"pointer",whiteSpace:"nowrap",flexShrink:0,fontFamily:DS.fontBody,transition:"background .15s, color .15s"}}>
                  {NAV_ICON[id] && <Icon name={NAV_ICON[id]} size={14} color={tab===id?"#1c2833":"#98a2ad"} />}
                  {String(label).replace(/^[^A-Za-zÀ-ÿ]+\s*/, '')}
                  {/* Couche confirmation : LE badge « À confirmer » (même
                      compte que la section de l'écran) — terracotta « ! »
                      quand une échéance d'empreinte passe sous 48 h. */}
                  {id === 'orchestrateur-horaires' && isAdmin && (
                    <NavBadge count={aConfirmer.count} urgent={aConfirmer.urgent > 0}
                      tone="#3d5166" testId="nav-badge-a-confirmer" />
                  )}
                  {/* LOT 2 — les pastilles de compte des sous-onglets qui en
                      portent : messages non répondus, demandes en attente,
                      incidents à traiter. Mêmes compteurs que les badges
                      parents — jamais un second calcul. */}
                  {id === 'messages' && isAdmin && (
                    <NavBadge count={notif.unreadInbox} tone="#3d5166"
                      testId="nav-badge-messages" />
                  )}
                  {id === 'voyageurs-demandes' && isAdmin && (
                    <NavBadge count={notif.pendingRequests} tone="#3d5166"
                      testId="nav-badge-demandes" />
                  )}
                  {id === 'incidents' && isAdmin && (
                    <NavBadge count={navBadgesIncidents} tone="#b8412b"
                      testId="nav-badge-incidents" />
                  )}
                </button>
              </Fragment>
            )
          })}
        </div>
      )}
    </>
  )
}
